const filterData = (dataToFilter = [], term = '') =>
    dataToFilter.filter(({ id, name, createdBy }) =>
        Object.values({ id, name, createdBy }).some((val) =>
            String(val).toLowerCase().includes(term.toLowerCase()),
        ),
    );

export default filterData;
